import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

const AddBed = ({ item, onAddDepart }) => {
    const [formData, setFormData] = useState({
        wards: [],
        bed_id: '',
        bed_ward: '', // Don't set default here
        bed_name: '',
        bed_price: '',
        bed_desc: '',
        bed_user: '',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
    });
    const [ldata, setLdata] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate bed_ward is selected
        if (!formData.bed_ward) {
            alert('Please select a ward');
            return;
        }

        const fd = new FormData();
        fd.append('bed_id', formData.bed_id);
        fd.append('bed_name', formData.bed_name);
        fd.append('bed_ward', formData.bed_ward); // This will now have the actual selected value
        fd.append('bed_price', formData.bed_price);
        fd.append('bed_desc', formData.bed_desc);
        fd.append('bed_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addBedUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    bed_id: '',
                    bed_ward: '',
                    bed_name: '',
                    bed_price: '',
                    bed_desc: '',
                    bed_user: '',
                    par_by: '',
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                document.getElementById("closeBt45").click();
                onAddDepart();
            } else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);

            var fd = new FormData();
            fd.append('cat_type', "ward");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log("Fetching wards...", JSON.stringify(response));
                
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            wards: records
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching wards:", error);
            }
        }
    };

    useEffect(() => {
        initData();
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
        }

        if (item) {
            console.log("Editing item:", item);
            if (item != null && item != undefined) {
                setFormData(prev => ({
                    ...prev,
                    bed_id: item.bed_id,
                    bed_name: item.bed_name,
                    bed_ward: item.bed_ward || item.cat_id, // Use cat_id if bed_ward is not available
                    bed_price: item.bed_price,
                    bed_desc: item.bed_desc,
                    bed_user: item.bed_user,
                }));
            }
        } else {
            setFormData(prev => ({
                ...prev,
                bed_id: '',
                bed_ward: '',
                bed_name: '',
                bed_price: '',
                bed_desc: '',
                bed_user: '',
                par_by: '',
            }));
        }

        return () => {
            console.log('Component unmounted');
        };
    }, [item]);

    return (
        <div className="modal fade" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
                        <h5 className="modal-title" id="exampleModalLabel">
                            {formData.bed_id ? 'Edit Bed' : 'Add Bed'}
                        </h5>
                        <button 
                            type="button" 
                            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn" 
                            data-bs-dismiss="modal" 
                            id="close-modal"
                        >
                            Close
                        </button>
                    </div>
                    
                    <form className="tablelist-form" onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <input id="id-field" type="hidden" />
                            
                            <div className="row gy-4 mb-3">
                                <div className="col-md-12">
                                    <div>
                                        <label htmlFor="bed_ward" className="form-label">
                                            Ward <span className="text-danger">*</span>
                                        </label>
                                        <select 
                                            className="form-control" 
                                            name="bed_ward" 
                                            onChange={handleChange}
                                            value={formData.bed_ward} 
                                            required
                                        >
                                            <option value="" disabled>Select the Ward</option>
                                            {formData.wards.map((item) => (
                                                <option key={item.cat_id} value={item.cat_id}>
                                                    {item.cat_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                
                                <div className="col-md-12">
                                    <div>
                                        <label htmlFor="bed_name" className="form-label">
                                            Bed Name <span className="text-danger">*</span>
                                        </label>
                                        <input 
                                            name="bed_name" 
                                            onChange={handleChange} 
                                            value={formData.bed_name} 
                                            className="form-control" 
                                            placeholder="Enter Bed Name" 
                                            type="text" 
                                            required 
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-md-12">
                                    <div>
                                        <label htmlFor="bed_price" className="form-label">
                                            Bed Price <span className="text-danger">*</span>
                                        </label>
                                        <input 
                                            name="bed_price" 
                                            onChange={handleChange} 
                                            value={formData.bed_price} 
                                            className="form-control" 
                                            placeholder="Enter Bed Price" 
                                            type="number"
                                            step="0.01"
                                            required 
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-md-12">
                                    <div>
                                        <label htmlFor="bed_desc" className="form-label">Description</label>
                                        <textarea 
                                            name="bed_desc" 
                                            onChange={handleChange} 
                                            value={formData.bed_desc} 
                                            className="form-control"
                                            placeholder="Enter Description..." 
                                            rows="3"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="modal-footer">
                            <div className="hstack gap-2 justify-content-end">
                                <button 
                                    type="button" 
                                    id="closeBt45" 
                                    className="btn btn-light" 
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                {formData.bed_id.length > 0 ? (
                                    <button type="submit" className="btn btn-success" id="edit-btn">
                                        Update
                                    </button>
                                ) : (
                                    <button type="submit" className="btn btn-success" id="add-btn">
                                        Add
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddBed;